


























































































































































import { Component, Vue } from "vue-property-decorator";
import OptionTemplateDialog from "./OptionTemplateDialog.vue";
import NameFormDialog from "./NameFormDialog.vue";
import Loading from "@/components/loader/loading.vue";
import { dateFormat } from "@/common/date_format";
import { Form, Forms, ResponseForm, StaffSurveyForm } from "@/api";
import { formStatus, getStatus } from "@/common/form_status";
import _ from "lodash";

@Component({
  components: {
    OptionTemplateDialog,
    NameFormDialog,
    Loading,
  },
  watch: {
    async $route() {
      this.$data.loading = true;
      const pathType = this.$route.params.slug;
      let dispatchType = "";
      if (pathType.includes("orientation")) dispatchType = "staff-orientation";
      else if (pathType.includes("satisfaction"))
        dispatchType = "staff-satisfaction";
      else if (pathType.includes("exit")) dispatchType = "staff-exit";
      else dispatchType = pathType;
      await this.$store.dispatch(
        "staffSurvey/getStaffSurveyForms",
        dispatchType,
      );
      this.$data.loading = false;
    },
  },
})
export default class FormList extends Vue {
  loading = false;
  createDialog = false;
  publishConfirm = false;
  nameConfirm = false;
  creating = false;
  selectedForm = 0;
  formatDate = dateFormat;
  getStatus = getStatus;
  formStatus = formStatus;
  status = -1;
  removing = false;
  copyConfirm = false;
  copying = false;
  deactivating = false;
  saved = false;

  headers = [
    {
      text: "",
      align: "start",
      value: "id",
      width: "5%",
    },
    {
      text: "Name",
      align: "start",
      sortable: false,
      value: "name",
      width: "60%",
    },
    {
      text: "Status",
      sortable: false,
      value: "status",
      width: "15%",
      align: "center",
    },
    {
      text: "Created",
      sortable: false,
      value: "createdAt",
      width: "20%",
      algin: "end",
    },
  ];

  async created() {
    this.loading = true;
    const dispatchType = this.getDispatchType();
    await this.$store.dispatch("staffSurvey/getStaffSurveyForms", dispatchType);
    this.loading = false;
  }

  getDispatchType() {
    const pathType = this.$route.params.slug;
    if (pathType.includes("orientation")) return "staff-orientation";
    else if (pathType.includes("satisfaction")) return "staff-satisfaction";
    else if (pathType.includes("exit")) return "staff-exit";
    else return pathType;
  }

  get forms() {
    const list = this.$store.getters["staffSurvey/staffSurveyForms"] as Forms;
    list?.map(form => {
      if (form.status === 3) this.selectedForm = form.id;
      return form;
    });
    if (list === null) return null;
    const forms = _.orderBy(list, ["status", "createdAt"], ["desc", "desc"]);
    if (this.status === -1) return forms;
    else return forms.filter(form => form.status === this.status);
  }

  async createBlank() {
    this.createDialog = !this.createDialog;
    this.nameConfirm = !this.nameConfirm;
  }

  async createTemplate() {
    this.createDialog = !this.createDialog;
  }

  async save(name: string) {
    this.creating = true;
    const dispatchType = this.getDispatchType();
    const payload: StaffSurveyForm = {
      id: 0,
      categoryId: 0,
      companyId: 0,
      name,
      status: 1,
      isStandard: false,
      createdAt: "",
    };
    await this.$store.dispatch("staffSurvey/createStaffSurveyForm", {
      slug: dispatchType,
      requestBody: payload,
    });
    this.creating = false;
    this.saved = true;
    this.nameConfirm = !this.nameConfirm;
  }

  goTo(form: ResponseForm) {
    this.$router.push(
      `/staff-survey/${this.getDispatchType()}/form/${form.id}/question`,
    );
  }

  async remove() {
    if (this.selectedForm > 0 && this.forms) {
      const requestBody = this.forms.filter(
        form => form.id === this.selectedForm,
      )[0];
      this.removing = true;
      const dispatchType = this.getDispatchType();
      await this.$store.dispatch("staffSurvey/archiveStaffSurveyForm", {
        slug: dispatchType,
        formId: requestBody.id,
      });
      this.removing = false;
    } else {
      this.$store.dispatch("alert/warning", "select a form to take action");
    }
  }

  async createCopy(name: string) {
    if (this.selectedForm > 0 && this.forms) {
      const form = this.forms.filter(form => form.id === this.selectedForm)[0];
      const requestBody = {
        companyId: form.companyId,
        name,
        isStandard: false,
      } as Form;
      this.copying = true;
      await this.$store.dispatch("staffSurvey/copyStaffSurveyForm", {
        formId: this.selectedForm,
        requestBody,
        dispatchType: this.getDispatchType(),
      });
      this.copying = false;
      this.copyConfirm = !this.copyConfirm;
    } else {
      this.$store.dispatch("alert/warning", "select a form to take action");
    }
  }

  async setInactive() {
    if (this.selectedForm > 0 && this.forms) {
      const requestBody = this.forms.filter(
        form => form.id === this.selectedForm,
      )[0];
      requestBody.status = 2;
      this.deactivating = true;
      const dispatchType = this.getDispatchType();
      await this.$store.dispatch("staffSurvey/updateStaffSurveyForm", {
        requestBody: requestBody,
        slug: dispatchType,
        formId: requestBody.id,
      });
      this.deactivating = false;
    } else {
      this.$store.dispatch("alert/warning", "select a form to take action");
    }
  }
}
